var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMmp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 36.026,
    viewBox: "0 0 80 36.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-mmp"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 80,
    height: 36.026,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    clipPath: "url(#clip-path-mmp)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M146.437,5.914A11.68,11.68,0,0,0,136.054,0a12.187,12.187,0,0,0-6.14,1.58,12.45,12.45,0,0,0-4.334,4.334A11.908,11.908,0,0,0,124,12.1a13.291,13.291,0,0,0,1.445,6.185,11.854,11.854,0,0,0,3.973,4.334,10.339,10.339,0,0,0,5.733,1.58,10.837,10.837,0,0,0,5.733-1.58,10.54,10.54,0,0,0,2.709-2.393V21.85a2.212,2.212,0,1,0,4.424,0V12.144a11.65,11.65,0,0,0-1.58-6.23",
    transform: "translate(-68.02 0)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M124.731,29.093a8.1,8.1,0,0,0-3.973-.993h-5.824a1.4,1.4,0,0,0-1.083.451,1.433,1.433,0,0,0-.451,1.129V49.905a1.4,1.4,0,0,0,.451,1.083,1.467,1.467,0,0,0,1.083.451,1.5,1.5,0,0,0,1.129-.451,1.467,1.467,0,0,0,.451-1.083V43.449h4.244a7.639,7.639,0,0,0,3.973-.993,7.1,7.1,0,0,0,2.709-2.709,7.923,7.923,0,0,0,.993-3.928,7.693,7.693,0,0,0-.993-4.018,7.422,7.422,0,0,0-2.709-2.709m.677,6.772a4.59,4.59,0,0,1-.587,2.393,4.32,4.32,0,0,1-1.625,1.625,4.647,4.647,0,0,1-2.438.587h-4.244V31.08h4.244a4.9,4.9,0,0,1,2.438.632,4.436,4.436,0,0,1,1.625,1.67,5.174,5.174,0,0,1,.587,2.483",
    transform: "translate(-62.205 -15.414)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M78.305,28.1a1.557,1.557,0,0,0-1.4.813L68.283,46.519,59.434,28.913a1.51,1.51,0,0,0-1.4-.813,1.4,1.4,0,0,0-1.083.451A1.433,1.433,0,0,0,56.5,29.68V49.905a1.4,1.4,0,0,0,.451,1.083,1.467,1.467,0,0,0,1.083.451,1.4,1.4,0,0,0,1.083-.451,1.467,1.467,0,0,0,.451-1.083V35.549L66.7,49.86a1.49,1.49,0,0,0,1.445.9A1.534,1.534,0,0,0,69.5,50L76.68,35.278V49.86a1.4,1.4,0,0,0,.451,1.083,1.5,1.5,0,0,0,1.129.451,1.541,1.541,0,0,0,1.535-1.535V29.635a1.338,1.338,0,0,0-.451-1.083,1.307,1.307,0,0,0-1.038-.451",
    transform: "translate(-30.993 -15.414)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M21.805,5.1a1.557,1.557,0,0,0-1.4.813L11.783,23.519,2.889,5.913A1.523,1.523,0,0,0,1.535,5.1a1.4,1.4,0,0,0-1.083.451A1.433,1.433,0,0,0,0,6.68V26.905a1.4,1.4,0,0,0,.451,1.083,1.467,1.467,0,0,0,1.083.451,1.4,1.4,0,0,0,1.083-.451,1.467,1.467,0,0,0,.451-1.083V12.549L10.2,26.86a1.49,1.49,0,0,0,1.445.9A1.534,1.534,0,0,0,13,27L20.18,12.278V26.86a1.4,1.4,0,0,0,.451,1.083,1.5,1.5,0,0,0,1.129.451,1.541,1.541,0,0,0,1.535-1.535V6.68A1.338,1.338,0,0,0,22.843,5.6a1.611,1.611,0,0,0-1.038-.5",
    transform: "translate(0 -2.798)",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmp);
export default __webpack_public_path__ + "static/media/mmp.1b29d8fccfb86b36378f8f10023b30e5.svg";
export { ForwardRef as ReactComponent };